import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Icon } from "@iconify/react";
import { getDashboardData } from "../../services/dashboardService";
import './UnitCountOne.css';

const UnitCountOne = () => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    loadDashboard();
  }, []);

  const loadDashboard = async () => {
    setLoading(true);
    const res = await getDashboardData();
    if (res && (res.status === "success" || res.status === true)) {
      setData(res.data);
    }
    setLoading(false);
  };

  if (loading) {
    return (
      <div className="unit-count-wrapper">
        <div className="dashboard-header">
          <h1 className="dashboard-title">Dashboard Overview</h1>
          <p className="dashboard-subtitle">Loading your dashboard data...</p>
        </div>
        <div className="row">
          {[...Array(10)].map((_, index) => (
            <div className="col" key={index}>
              <div className="dashboard-card loading">
                <div className="card-body">
                  <div className="d-flex justify-content-between align-items-center">
                    <div className="stat-info">
                      <p className="stat-label">Loading...</p>
                      <h6 className="stat-value">---</h6>
                    </div>
                    <div className="icon-box" style={{ backgroundColor: '#cbd5e1' }}>
                      <Icon icon="mdi:loading" className="text-white" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    );
  }

  if (!data) {
    return (
      <div className="unit-count-wrapper">
        <div className="dashboard-header">
          <h1 className="dashboard-title">Dashboard Overview</h1>
          <p className="dashboard-subtitle">Welcome to your dashboard</p>
        </div>
        <div className="no-data">
          <Icon icon="mdi:chart-box" className="no-data-icon" />
          <p>No data available</p>
        </div>
      </div>
    );
  }

  const cardConfig = [
    { 
      label: "Total Users", 
      value: data.total_users, 
      path: "/user-list", 
      icon: "mdi:account-group-outline", 
      color: "#6366f1",
      gradient: "linear-gradient(135deg, #6366f1, #4f46e5)"
    },
    { 
      label: "Team Managers", 
      value: data.total_tm, 
      path: "/teams-list", 
      icon: "mdi:account-tie-outline", 
      color: "#9c27b0",
      gradient: "linear-gradient(135deg, #9c27b0, #7b1fa2)"
    },
    { 
      label: "Sales Executives", 
      value: data.total_sales, 
      path: "/assign-list", 
      icon: "mdi:briefcase-account-outline", 
      color: "#03a9f4",
      gradient: "linear-gradient(135deg, #03a9f4, #0288d1)"
    },
    { 
      label: "Active Users", 
      value: data.active_users, 
      path: "/user-list", 
      icon: "mdi:account-check-outline", 
      color: "#10b981",
      gradient: "linear-gradient(135deg, #10b981, #059669)"
    },
    { 
      label: "Inactive Users", 
      value: data.inactive_users, 
      path: "/user-list", 
      icon: "mdi:account-off-outline", 
      color: "#ef4444",
      gradient: "linear-gradient(135deg, #ef4444, #dc2626)"
    },
    { 
      label: "Total Schools", 
      value: data.total_schools, 
      path: "/school-list", 
      icon: "mdi:school-outline", 
      color: "#f59e0b",
      gradient: "linear-gradient(135deg, #f59e0b, #d97706)"
    },
    { 
      label: "Total Classes", 
      value: data.total_classes, 
      path: "/school-file", 
      icon: "mdi:google-classroom", 
      color: "#607d8b",
      gradient: "linear-gradient(135deg, #607d8b, #546e7a)"
    },
    { 
      label: "Total Teachers", 
      value: data.total_teachers, 
      path: "/school-file", 
      icon: "mdi:human-male-board", 
      color: "#e91e63",
      gradient: "linear-gradient(135deg, #e91e63, #c2185b)"
    },
    { 
      label: "Total Students", 
      value: data.total_students, 
      path: "/school-file", 
      icon: "mdi:face-man-shimmer-outline", 
      color: "#3f51b5",
      gradient: "linear-gradient(135deg, #3f51b5, #303f9f)"
    },
    { 
      label: "Total Photos", 
      value: data.total_photos, 
      path: "/school-file", 
      icon: "mdi:image-multiple-outline", 
      color: "#795548",
      gradient: "linear-gradient(135deg, #795548, #5d4037)"
    },
  ];

  return (
    <div className="unit-count-wrapper">
      <div className="dashboard-header">
        <h3 className="">Dashboard Overview</h3>
        <p className="dashboard-subtitle">Welcome back! Here's what's happening with your platform today.</p>
      </div>
      
      <div className="row">
        {cardConfig.map((item, index) => (
          <div className="col" key={index}>
            <div 
              className="dashboard-card"
              onClick={() => navigate(item.path)}
              role="button"
              tabIndex={0}
              onKeyPress={(e) => {
                if (e.key === 'Enter' || e.key === ' ') {
                  navigate(item.path);
                }
              }}
            >
              <div className="card-body">
                <div className="d-flex justify-content-between align-items-center">
                  <div className="stat-info">
                    <p className="stat-label">{item.label}</p>
                    <h6 className="stat-value">{item.value?.toLocaleString() || 0}</h6>
                  </div>
                  <div className="icon-box" style={{ background: item.gradient }}>
                    <Icon icon={item.icon} className="text-white" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default UnitCountOne;